import { render } from "./ProjectsListTestador.vue?vue&type=template&id=39598b3b&scoped=true"
import script from "./ProjectsListTestador.vue?vue&type=script&lang=js"
export * from "./ProjectsListTestador.vue?vue&type=script&lang=js"

import "./ProjectsListTestador.vue?vue&type=style&index=0&id=39598b3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39598b3b"]])

export default __exports__